import { isPlatformBrowser } from '@angular/common'
import { ErrorHandler, inject, Injectable, PLATFORM_ID } from '@angular/core'
import { ErrorLogService } from '@shared/services/error-log.service'

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService implements ErrorHandler {
  private platformId = inject(PLATFORM_ID)
  private errorLogService = inject(ErrorLogService)

  handleError(error: any) {
    this.errorLogService.log(error, 'ErrorHandlerService', '')

    const chunkFailedMessage =
      /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/
    if (chunkFailedMessage.test(error.message)) {
      console.warn('Chunk load error, reloading...', error)
      this.reloadPage()
    } else {
      console.error(error)
    }
  }

  reloadPage() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload()
    }
  }
}
